import React, { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { motion, AnimatePresence } from 'framer-motion';
import { updateWelcomeScreen } from '../store/globalReducer';

import '../assets/scss/components/welcomeScreen.scss';

import logoBg from '../assets/img/common/logo_beige.svg';
import welcomeTitle from '../assets/img/common/title_welcome_pc.svg';
import welcomeTitleSP from '../assets/img/common/title_welcome_sp.svg';
import welcomeFlower from '../assets/img/common/welcome_flower.png';


export default function WelcomeScreen() {
  const dispatch = useDispatch();

  const isWelcomeScreenHidden = useSelector(state => state.global.isWelcomeScreenHidden);

  const handleClick = e => {
    e.preventDefault();
    dispatch(updateWelcomeScreen(true));
  }

  return (
    <AnimatePresence>
      {!isWelcomeScreenHidden && (
        <motion.div
          className="welcome"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}>
          <div className="welcome__container">
            <div className="welcome__wrap">
              <div className="welcome__textbox">
                <div className="welcome__title">
                  <img className="welcome__title-text sp-hide" src={welcomeTitle} alt="牧野マップ with 桂浜" />
                  <img className="welcome__title-text sp-show" src={welcomeTitleSP} alt="牧野マップ with 桂浜" />
                  <img className="welcome__title-img" src={welcomeFlower} />
                </div>
                <div className="welcome__text">
                  <p>
                    県内各地をくまなく歩いた<br className="sp-hide" />
                    牧野博士。<br />
                    その足跡をたどってみると、<br />
                    新たな高知が見えるかも？<br />
                    生まれ変わった<br className="sp-hide" />
                    桂浜のスポットも紹介。<br />
                    さあ、博士と高知を<br className="sp-hide" />
                    歩いてみよう！
                  </p>
                </div>
              </div>
              <div className="welcome__btn"><a href="#" onClick={handleClick}>はじめる</a></div>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}


